const white = {
  solid: '#FFFFFF',
};

export default white;
